let pending = null;
const listeners = new Set();

export const onChallenge = (fn) => { listeners.add(fn); return () => listeners.delete(fn); };

// Ask the mounted ChallengeHost for a fresh Turnstile token (shared across concurrent requests).
export const requestChallenge = () => {
  if (!pending) {
    pending = new Promise((resolve, reject) => listeners.forEach((fn) => fn({ resolve, reject })))
      .finally(() => { pending = null; });
    if (!listeners.size) return Promise.reject(new Error("no challenge host"));
  }
  return pending;
};
